import React from "react";
import { Feedbacks } from "../../components/Feedbacks";
import { connect } from "react-redux";

class FeedbackScreen extends React.Component {
  render() {
    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <Feedbacks />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(FeedbackScreen);
